import type { DestroyOptions } from '../../types';
import { TimeAwareTextAsset } from './TimeAwareTextAsset';

export class GraphicStyleTextAsset extends TimeAwareTextAsset {
    /**
     GraphicStyleTextAsset is a primitive text object that makes adding backgrounds to TextAssets
     simple.
    **/
    override _classType = 'GraphicStyleTextAsset'; // should match VideoData.TEXT_ASSET_TYPE

    override clear() {
        super.clear();

        // clear animation
        this.clearAnimation();
    }

    override destroy(options?: DestroyOptions) {
        super.destroy(options);
        this.clear();
    }
}
